import { Role } from "../../helpers/role";

export const ManagementRoutes = [
  {
    name: "ManagementRoutes",
    path: `/${Role.Management}`,
    redirect: `/${Role.Management}/olt-list`,
    component: () => import("@/layouts/Layout"),
    children: [
      {
        name: "OltList",
        path: "olt-list",
        component: () => import("@/views/management/OltList"),
        meta: {
          authorize: [Role.Management],
        },
      },

      {
        name: "ApList",
        path: "ap-list",
        component: () => import("@/views/management/ApList"), // src\views\management\APList.vue
        meta: {
          authorize: [Role.Management],
        },
      },

      {
        name: "SearchOnu",
        path: "search-onu",
        component: () => import("@/views/management/SearchOnu"), // src\views\management\APList.vue
        meta: {
          authorize: [Role.Management],
        },
      },
      {
        name: "CheckOlt",
        path: "check-olt",
        component: () => import("@/views/management/CheckOlt"), // src\views\management\APList.vue
        meta: {
          authorize: [Role.Management],
        },
      },
      {
        name: "SearchPayment",
        path: "search-payment",
        component: () => import("@/views/management/SearchPayment"), // src\views\management\APList.vue
        meta: {
          authorize: [Role.Management],
        },
      },
      {
        name: "ReleaseOnu",
        path: "release-onu",
        component: () => import("@/views/management/ReleaseOnu"), // src\views\management\APList.vue
        meta: {
          authorize: [Role.Management],
        },
      },
      {
        name: "ChangeOnu",
        path: "change-onu",
        component: () => import("@/views/management/ChangeOnu"), // src\views\management\APList.vue
        meta: {
          authorize: [Role.Management],
        },
      },
      {
        name: "CheckReference",
        path: "check-reference",
        component: () => import("@/views/management/CheckReference"), // src\views\management\APList.vue
        meta: {
          authorize: [Role.Management],
        },
      },
      {
        name: "ActivationList",
        path: "activation-list",
        component: () => import("@/views/management/ActivationList"), // src\views\management\APList.vue
        meta: {
          authorize: [Role.Management],
        },
      },
    ],
  },
];
